/** @format */
import React, { useEffect, useState, useImperativeHandle, forwardRef } from 'react'
import styled from 'styled-components'
import { _$, Button, Select, Option, Icon, Message, Form, FormItem } from '@king-design/react'
import { MonitorSearch, TablePage } from 'src/components'
import useTableGroup from 'src/hooks/useTableGroup'
import useFormTable from 'src/hooks/useFormTable'
import { InstanceItem, ProductItem } from 'src/utils/interface'
import { QueryKeyEnum } from 'src/utils/unit'
import { productObj, podOptions } from 'src/components/SelectInstance/SelectInstanceTabs/constants'
// eslint-disable-next-line max-len
import CloudListTableCopyTips from 'src/containers/MonitorCloud/CloudListTable/CloudListTableCopyTips'
import { request } from 'src/utils'
import ApiCloud from 'src/api/ApiCloud'
import { set, omit } from 'lodash'
import { useUpdateEffect } from 'react-use'
import Cookie from 'js-cookie'

interface SelectedInstanceProps {
  className?: string
  groupId: string
  childTypes: ProductItem[]
  productType: number
  addInstances: string[]
  setInstances: (values: string[]) => void
}

export interface SelectedInstanceHandle {
  getValues: () => string[]
}

const lang = Cookie.get('ksc_lang')
const SelectedInstance = forwardRef<SelectedInstanceHandle, SelectedInstanceProps>(
  ({ className, groupId, productType, childTypes, addInstances, setInstances }, ref) => {
    // 产品线筛选
    const [childValue, setChildValue] = useState<number>()
    const [subList, setSubList] = useState<InstanceItem[]>()
    const [subValue, setSubValue] = useState<string>('')
    // 容器引擎-POD(45)、MongoDB分片集群-Shard节点(53)
    const [shardList, setShardList] = useState<InstanceItem[]>([])
    const [shardValue, setShardValue] = useState<string>('')
    const [workload, setWordload] = useState<string>(podOptions[0])
    // 表格筛选
    const [queryKey, setQueryKey] = useState<string>('InstanceName')
    const [query, setQuery] = useState<string>('')
    const regionList = useTableGroup('monitorRegionList')
    const [tableGroup, setTableGroup] = useState({ region: '' })
    const [tableCheckes, setTableChecks] = useState<string[]>([])
    const [tableData, setTableData] = useState<InstanceItem[]>([])
    const [tableTotal, setTableTotal] = useState<number>(0)
    const [tableInfo, setTableInfo] = useState<boolean>(false)
    // 新增实例
    // const [addInstances, setAddInstances] = useState<string[]>([])
    // 保存run请求参数，筛选的时候会用到
    const [runParams, setRunParams] = useState<any>({})

    // 重置所有筛选项
    const resetValues = () => {
      setQuery('')
      setQueryKey('InstanceName')
      setTableGroup({ region: '' })
      setTableData([])
      setTableTotal(0)
      setRunParams({})
      return {
        PageIndex: 1,
        PageSize: 10,
        InstanceId: '',
        InstanceName: '',
        InstanceIP: '',
        RegionKey: ''
      }
    }

    // 重置所有属性筛选
    const resetProps = () => {
      setSubList([])
      setSubValue('')
      setShardList([])
      setShardValue('')
      setWordload(podOptions[0])
    }

    useEffect(() => {
      const initParams = resetValues()
      resetProps()
      setInstances([])
      if (productType !== undefined && childTypes?.length) {
        setChildValue(childTypes[0].productType)
      } else {
        setChildValue(prev => {
          if (!prev) {
            setRunParams({})
            run(initParams)
          }
          return undefined
        })
      }
    }, [productType])

    // 切换childValue 获取subList
    useUpdateEffect(() => {
      resetProps()
      const initParams = resetValues()
      if (childValue) {
        const obj = productObj[childValue]
        if (obj) {
          getSubList()
        } else {
          setSubList([])
          const parmas = {
            ProductType: childValue
          }
          setRunParams(parmas)
          run({ ...parmas, ...initParams })
        }
      } else {
        setRunParams({})
        run(initParams)
      }
    }, [childValue])

    const getSubList = async () => {
      const obj = productObj[childValue]
      const result = await request(ApiCloud.getInstanceList, {
        data: {
          ProductType: obj.topType,
          PageIndex: 1,
          PageSize: 9999
        }
      })
      if (result.code === 'Success') {
        const { resourceList } = result?.data
        setSubList(resourceList)
        setSubValue(resourceList?.length ? resourceList[0].instanceId : '')
      }
    }

    // 选择subValue
    useUpdateEffect(() => {
      const obj = productObj[childValue]
      if (obj?.topType) {
        const initParams = resetValues()
        setShardList([])
        setShardValue('')
        if (subValue) {
          if (obj.shardTitle) {
            getShardList()
          } else {
            const params = {
              ProductType: parseInt(obj.productType),
              ParentInstanceIds: [subValue],
              ChildType: obj.shardId || childValue
            }
            setRunParams(params)
            run({ ...params, ...initParams })
          }
        }
      }
    }, [subValue])
    // prdouctType=45/53 请求第三级列表
    const getShardList = async () => {
      const obj = productObj[childValue]
      const params = {
        ProductType: parseInt(obj.productType),
        ParentInstanceIds: [subValue],
        PageSize: 9999,
        Field: obj.topType === 28 && childValue === 45 ? 'namespace' : undefined,
        ChildType: childValue === 53 ? 52 : undefined
      }
      const result = await request(ApiCloud.getChildInstance, {
        method: 'POST',
        data: params
      })
      if (result.code === 'Success') {
        const { resourceList } = result?.data
        setShardList(resourceList)
        setShardValue(resourceList?.length ? resourceList[0].instanceId : '')
      }
    }

    //  prdouctType=45/53 请求表格数据处理
    useUpdateEffect(() => {
      const obj = productObj[childValue]
      if (shardValue && obj) {
        const initParams = resetValues()
        const params = {
          ProductType: parseInt(obj.productType)
        }
        if (childValue === 45 && workload) {
          // 容器引擎-POD(45)
          set(params, 'ParentInstanceIds', [subValue])
          set(params, 'Condition', {
            Namespace: shardValue,
            Workloadtype: workload
          })
          setRunParams(params)
          run({ ...params, ...initParams })
        } else if (childValue === 53) {
          // MongoDB分片集群-Shard节点(53)
          set(params, 'ParentInstanceIds', [shardValue])
          set(params, 'ChildType', childValue)
          setRunParams(params)
          run({ ...params, ...initParams })
        }
      }
    }, [shardValue, workload])

    // table公用请求
    const { run, pageState, loading } = useFormTable(
      productObj[childValue] ? ApiCloud.getChildInstance : ApiCloud.getInstanceList,
      {
        manual: true,
        method: productObj[childValue] ? 'POST' : 'GET',
        params: {
          FilterGroupId: parseInt(groupId),
          ProductType: childValue || productType,
          PageIndex: 1,
          PageSize: 10,
          InstanceId: '',
          InstanceName: '',
          InstanceIP: '',
          [queryKey]: query,
          RegionKey: tableGroup.region,
          ...runParams
        }
      },
      data => {
        const properties = data?.resourceList?.find(item => {
          return item?.properties?.length
        })
        setTableInfo(!!properties)
        const datas = data?.resourceList || []
        const total = data?.totalCount || 0
        setTableData(datas)
        setTableTotal(total)
        return {
          tableData: datas,
          totalCount: total
        }
      },
      params => {
        if (!productObj[childValue]) {
          return omit(params, ['ParentInstanceIds', 'ChildType', 'Condition'])
        }
        return params
      }
    )

    // 添加实例
    const add = (list: string[]) => {
      const filter = list.filter(item => {
        return !addInstances.includes(item)
      })
      if (addInstances?.length + filter?.length > 500) {
        Message.error(_$('自选实例单次最多添加500个资源'))
      } else {
        setInstances([...addInstances, ...filter])
        const updateCheckes = tableCheckes.filter(item => !list.includes(item))
        setTableChecks(updateCheckes)
      }
    }

    // 移除实例
    const remove = (instanceId: string) => {
      const filter = addInstances.filter(item => item !== instanceId)
      setInstances(filter)
    }

    // table scheme
    const getTableScheme = () => {
      const scheme = {
        instanceName: {
          title: _$('实例名称'),
          width: tableInfo ? 180 : 250,
          template: ({ instanceId, instanceName }) => (
            <div className="table-name">
              <span>{instanceName}</span>
              <CloudListTableCopyTips instanceId={instanceId} margin={true} />
            </div>
          )
        },
        instanceIP: {
          title: _$('实例信息'),
          width: tableInfo ? 100 : 200
        },
        region: {
          title: _$('region'),
          width: 150,
          group: regionList,
          template(item) {
            if (lang === 'en') {
              return item.region
            } else {
              const find = regionList.find(region => region.value === item.region)
              return find?.label || item.region
            }
          }
        },
        properties: {
          title: _$('备注'),
          template({ properties }) {
            return properties?.length
              ? properties.map(({ name, value }) =>
                  name && value ? (
                    <p style={{ margin: 0 }}>
                      {name}：{value}
                    </p>
                  ) : (
                    ''
                  )
                )
              : ''
          }
        },
        action: {
          title: _$('操作'),
          width: 80,
          template(item) {
            const { instanceId, groupBindStatus } = item
            return groupBindStatus === 0 ? (
              addInstances.includes(instanceId) ? (
                <Button
                  size="small"
                  onClick={() => {
                    remove(instanceId)
                  }}
                >
                  {_$('移除')}
                </Button>
              ) : (
                <Button
                  type="primary"
                  size="small"
                  onClick={() => {
                    add([instanceId])
                  }}
                >
                  {_$('添加')}
                </Button>
              )
            ) : (
              <span style={{ color: '#999', lineHeight: '24px' }}>{_$('已添加')}</span>
            )
          }
        }
      }
      if (productObj[childValue]) {
        delete scheme.region
      }
      if (!tableInfo) {
        delete scheme.properties
      }
      return scheme
    }

    // 返回数据
    useImperativeHandle(ref, () => ({
      getValues: () => addInstances
    }))

    return (
      <div className={className}>
        {childTypes?.length ? (
          <div className="filter-porduct">
            <Form>
              <FormItem label={_$('类型')} value={childValue}>
                <Select
                  value={childValue}
                  filterable
                  onChangeValue={val => {
                    setChildValue(val)
                  }}
                >
                  {childTypes.map(item => {
                    return (
                      <Option key={item.productType} value={item.productType}>
                        {item.productName}
                      </Option>
                    )
                  })}
                </Select>
              </FormItem>
              {productObj[childValue] ? (
                <FormItem label={_$(productObj[childValue].subTitle)} value={subValue}>
                  <Select value={subValue} filterable onChangeValue={val => setSubValue(val)}>
                    {subList.map(item => (
                      <Option key={item.instanceId} value={item.instanceId}>
                        {item.instanceName}
                      </Option>
                    ))}
                  </Select>
                </FormItem>
              ) : null}
              {productObj[childValue]?.shardTitle ? (
                <FormItem label={_$(productObj[childValue].shardTitle)} value={shardValue}>
                  <Select value={shardValue} filterable onChangeValue={val => setShardValue(val)}>
                    {shardList.map(item => (
                      <Option key={item.instanceId} value={item.instanceId}>
                        {childValue === 45 ? item.instanceId : item.instanceName}
                      </Option>
                    ))}
                  </Select>
                </FormItem>
              ) : null}
              {childValue === 45 ? (
                <FormItem value={workload} label={_$('Workload Type')}>
                  <Select
                    container=".select_position"
                    width={400}
                    filterable
                    value={workload}
                    onChangeValue={val => setWordload(val)}
                  >
                    {podOptions?.length
                      ? podOptions.map(item => (
                          <Option key={item} value={item}>
                            {item}
                          </Option>
                        ))
                      : null}
                  </Select>
                </FormItem>
              ) : null}
            </Form>
          </div>
        ) : null}
        <div className="header">
          <Button
            type="primary"
            disabled={!tableCheckes?.length}
            onClick={() => {
              add(tableCheckes)
            }}
          >
            <Icon className="ion-plus-round" />
            {_$('批量添加')}
          </Button>
          <MonitorSearch
            prepend={
              <React.Fragment>
                <Select
                  value={queryKey}
                  onChangeValue={value => {
                    setQueryKey(value)
                    if (query) {
                      run({
                        PageIndex: 1,
                        InstanceId: '',
                        InstanceName: '',
                        InstanceIP: '',
                        [value]: query
                      })
                    }
                  }}
                  width="150"
                >
                  <Option value="InstanceName">{_$('实例名称')}</Option>
                  <Option value="InstanceId">{_$('实例Id')}</Option>
                  <Option value="InstanceIP">{_$('实例信息')}</Option>
                </Select>
              </React.Fragment>
            }
            width={400}
            placeholder={_$(`请输入${QueryKeyEnum[queryKey]}`)}
            value={query}
            onChange={value => {
              setQuery(value.trim())
              run({
                PageIndex: 1,
                InstanceId: '',
                InstanceName: '',
                InstanceIP: '',
                [queryKey]: value.trim()
              })
            }}
          />
        </div>
        <TablePage
          tableProps={{
            data: tableData,
            scheme: getTableScheme(),
            rowKey: item => item.instanceId,
            checkedKeys: tableCheckes,
            onChangeCheckedKeys: item => {
              setTableChecks(item)
            },
            disableRow: data => {
              // console.log(data)
              const { groupBindStatus, instanceId } = data
              return groupBindStatus === 1 || addInstances.includes(instanceId)
            },
            group: tableGroup,
            onChangeGroup: value => {
              if (value.region !== tableGroup.region) {
                setTableGroup(value)
                run({
                  PageIndex: 1,
                  RegionKey: value.region
                })
              }
            },
            rowCheckable: false
          }}
          pageProps={{ total: tableTotal, ...pageState }}
          loading={loading}
          run={run}
        />
      </div>
    )
  }
)

export default styled(SelectedInstance)`
  .filter-porduct {
    padding-bottom: 16px;
    .k-label {
      width: auto;
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
  .k-table {
    margin-top: 16px;
    .table-name {
      display: inline-block;
      span {
        margin-bottom: 0;
        margin-right: 8px;
        word-break: break-all;
      }
    }
  }
`
